export default __webpack_public_path__ + "static/media/logoWhite.5407a58d.svg";